import OutlineDB from '../db/outline-db'
import CacheDB from '../db/cache-db'
import VersionDB from '../db/version-db'
import { nowDateString } from '@/views/question-editor/components/question-cache-box/utils'

let queues = {}

class Cache {
  constructor (config) {
    this.config = {
      cacheMax: 30,
      versionMax: 30,
      ...config,
    }
    this.version = new VersionDB(this.config)
    this.outline = new OutlineDB(this.config)
    this.cache = new CacheDB(this.config)

    this.outline.get('temp').then((temp) => {
      if (temp) {
        // 判断该版本是否存在
        this.cache.get(temp.key).then((versions) => {
          let index = -1
          // 获得数据的 MD5 key
          let versionKey = this.version.makeKey(temp.key, temp.data)
          // 判断版本key是否存在
          if (versions) {
            index = versions.findIndex(({key}) => key === versionKey)
          } else {
            versions = []
          }
          // 不存在则写入该版本
          if (index === -1) {
            versions.push({
              key: versionKey,
              created_at: temp.created_at,
              updated_at: temp.updated_at,
            })

            Promise.all([
              this.cache.set(temp.key, versions),
              this.version.set(versionKey, temp.data),
            ]).then(() => {
              // 判断是否超出最大缓存数
              this.removeCacheMax(temp.key)
              // 判断是否超出最大版本数
              this.removeVersionMax(temp.key)
            })
          }
        })
        // 移除临时缓存
        this.outline.remove('temp')
      }
    })
  }

  getVersion (key) {
    return this.version.get(key)
  }

  set (key, data) {
    queues[key] = data
    return this.nextSet()
  }

  nextSet () {
    let setKeys = Object.keys(queues)
    if (setKeys.length) {
      let key = setKeys[0]
      let data = queues[key]
      return new Promise((resolve, reject) => {
        this.outline.get('temp').then((temp) => {
          // 获得创建该缓存的时间
          let createdAt = nowDateString()
          if (temp) {
            createdAt = temp.created_at
          }
          // 写入临时缓存
          this.outline.set('temp', {
            key,
            data,
            created_at: createdAt,
            updated_at: nowDateString(),
          }).then(resolve, reject).finally(() => {
            delete queues[key]
            this.nextSet()
          })
        })
      })
    }
  }

  table (key) {
    return this.cache.get(key)
  }

  remove (key) {
    this.cache.get(key).then((versions) => {
      if (versions) {
        this.version.remove(versions.map(({key}) => key))
        this.cache.remove(key)
      }
    })
  }

  removeCacheMax (key) {
    // 判断是否超出最大缓存数
    this.outline.get('cacheKeys').then((cacheKeys) => {
      if (cacheKeys) {
        // 加入新的key
        if (!cacheKeys.includes(key)) {
          cacheKeys.push(key)
        }
        // 缓存数超出，删除最旧的记录
        if (cacheKeys.length > this.config.cacheMax) {
          this.remove(cacheKeys[0])
          cacheKeys.splice(0, 1)
        }
        // 更新缓存key列表
        this.outline.set('cacheKeys', cacheKeys)
      } else {
        this.outline.set('cacheKeys', [key])
      }
    })
  }

  removeVersionMax (key) {
    // 判断是否超出最大缓存数
    this.cache.get(key).then((versions) => {
      if (versions) {
        // 缓存数超出，删除最旧的记录
        if (versions.length > this.config.versionMax) {
          this.version.remove(versions[0].key)
          versions.splice(0, 1)
          // 更新缓存key列表
          this.cache.set(key, versions)
        }
      }
    })
  }
}

export { Cache }
export default Cache



// WEBPACK FOOTER //
// ./src/views/question-editor/components/question-cache-box/src/cache.js